<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <router-view />
    </div>
  </a-config-provider>
</template>

<script>
import { message, Modal, ConfigProvider } from 'ant-design-vue';
import api from './request';
import Vue from 'vue';
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
import { publicPath } from './request/public';
Vue.prototype.$message = message;
Vue.prototype.$modal = Modal;
Vue.prototype.$publicPath = publicPath;
export default {
  name: 'App',
  components: { AConfigProvider: ConfigProvider },
  data() {
    return {
      locale: zhCN,
    };
  },
  mounted() {
    api.GetApplyList(1).then((res) => {
      this.$store.dispatch('setUnreadCount', res.unread_count);
    });
  },
  watch: {
    $route(to) {
      if (to.fullPath !== '/login' && to.fullPath !== '/register') {
        sessionStorage.setItem('last-path', to.fullPath);
      }
    },
  },
};
</script>

<style>
@import './styles/index.css';
</style>



// WEBPACK FOOTER //
// src/App.vue